import { useState } from "react";
import { useRouter } from "next/router";
import { FiLink } from "react-icons/fi";
import { site } from "config";

import socialShareStyles from "./SocialShare.module.scss";
import styles from "./CopyUrl.module.scss";

export default function CopyUrl({ iconConfig }) {
  const [isCopyUrlPopoverOpen, setIsCopyUrlPopoverOpen] = useState(false);

  const { asPath } = useRouter();

  const url = `${site}${asPath}`.split("#")[0];

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(url);

    setIsCopyUrlPopoverOpen(true);
    setTimeout(() => {
      setIsCopyUrlPopoverOpen(false);
    }, 2000);
  };

  return (
    <>
      <button
        className={`${styles.copyUrlButton} ${socialShareStyles.link}`}
        onClick={handleCopyUrl}
        onKeyDown={handleCopyUrl}
      >
        <FiLink {...iconConfig} />
      </button>

      <div
        className={`${styles.copyUrlPopover} ${
          isCopyUrlPopoverOpen ? styles.active : ""
        } wn-share-copy-url-popover`}
      >
        <p>Link copied to clipboard</p>
      </div>
    </>
  );
}
